import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Import components
import HomePage from "./pages/HomePage";
import PackageDetailPage from "./pages/PackageDetailPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ScrollToTop from "./components/ScrollToTop";
import { Spinner, SpinnerContainer } from './styles/Spinner';
import NotFound from "./pages/NotFound";
import TermsAndConditions from "./components/TermsConditions.js";
import PrivacyPolicy from "./components/PrivacyPolicy.js"
import RefundPolicy from "./components/RefundPolicy.js";
import Faq from "./components/Faq.js"

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div style={{ minHeight: '100vh' }}>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              borderRadius: '0.5rem',
              padding: '0.75rem',
              fontSize: '0.875rem',
              fontWeight: '500',
            },
          }}
        />

        <ScrollToTop />

        {loading ? (
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
        ):(
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path='/package/:id' element={<PackageDetailPage />} />
          <Route path="/service/:id" element={<ServiceDetailPage />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/RefundPolicy" element={<RefundPolicy />} />
          <Route path="/faq" element={<Faq />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
